import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/NewsFeeds/Wetland/8.jpg";
import Card3 from "../Images/NewsFeeds/Wetland/East.jpg";
import Card4 from "../Images/NewsFeeds/Wetland/9.jpg";
import Card5 from "../Images/NewsFeeds/Wetland/2.jpg";

function WorldWetlandsDay() {
  return (
    <div className="art-page">
      <SEO
        title="Celebrating World Wetlands Day"
        description="On this World Wetlands Day, let's celebrate all efforts towards restoring and preserving these vital ecosystems!"
        keywords="world wetlands day, wetlands, conservation, Uganda, biodiversity, ecosystem, CIRCODU, wetland restoration, wetland preservation, wetland ecosystems, wetland conservation Uganda, biodiversity in wetlands Uganda, ecosystem services wetlands Uganda, wetland restoration projects Uganda, wetland preservation initiatives Uganda, CIRCODU wetland work Uganda"
        url="/Celebrating-World-Wetlands-Day"
        image={Card3}
        datePublished="2024-02-02"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Celebrating World Wetlands Day
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 2, 2024
            </div>

            <h1 className="art-title">Celebrating World Wetlands Day</h1>

            <div className="texty">
              <p>
                On this World Wetlands Day, let's celebrate all efforts towards
                restoring and preserving these vital ecosystems! Let's reflect
                on the critical role wetlands play in our ecosystem — serving as
                natural water filters, carbon sinks, flood buffers, and
                biodiversity hotspots — and the urgent need to protect them
                before further degradation takes hold.
              </p>
              <img
                src={Card1}
                alt="Limoto Wetland in Kibuku district"
                className="art-img"
              />

              <h2 className="art-subheading">
                A National Commitment to Wetland Restoration
              </h2>
              <p>
                The Government of Uganda, through the Ministry of Water and
                Environment, Directorate of Water Resources Management, and with
                the support from the Green Climate Fund and UNDP, is
                implementing an ambitious 8-year project —{" "}
                <strong>
                  Building Resilient Communities, Wetland Ecosystems and
                  Associated Catchments in Uganda
                </strong>{" "}
                — aimed at restoring wetlands, rehabilitating catchments, and
                empowering communities with sustainable land management
                practices, reforestation, resilient agricultural practices, and
                alternative livelihoods.
              </p>
              <p>
                The project is being implemented across{" "}
                <strong>24 districts</strong> of Eastern and South-Western
                Uganda. To date, it has restored{" "}
                <strong>38,941 hectares</strong> of wetlands and rehabilitated{" "}
                <strong>6,655 hectares</strong> of degraded catchment, among
                other significant achievements — a remarkable demonstration of
                what coordinated, multi-stakeholder action can accomplish.
              </p>
              <img src={Card5} alt="Wetland in Uganda" className="art-img" />

              <h2 className="art-subheading">CIRCODU's Contribution</h2>
              <p>
                Centre for Integrated Research and Community Development Uganda
                (CIRCODU), alongside Technology Consults (TECO), is proud to
                have contributed to these efforts. Our team undertook a detailed
                design of small-scale water storage and detention facilities, as
                well as a detailed plan for silt traps, drainage, flood control,
                and maximum water recuperation for the restoration of wetlands
                under the project. This technical groundwork ensures that
                restored wetlands can sustain themselves effectively and
                continue delivering ecosystem services to surrounding
                communities long after project completion.
              </p>
              <img
                src={Card3}
                alt="Design of water storage facilities"
                className="art-img"
              />

              <h2 className="art-subheading">A Call to Action</h2>
              <p>
                Let's honour the dedication of local leaders, stakeholders, and
                communities working tirelessly to protect our wetlands. From the
                farmers adapting their practices along wetland edges to the
                engineers designing retention systems, every contribution
                matters. Together, we can ensure these invaluable ecosystems
                thrive for generations to come.
              </p>
              <p>
                Let's all support wetland conservation for a healthier planet
                and a thriving community — resonating deeply with this year's
                theme: <strong>"Wetlands and Human Wellbeing"</strong>.
              </p>
            </div>
            <img src={Card4} alt="Wetland in Uganda" className="art-img" />

            <div className="art-cta">
              <p>
                Want to learn more about CIRCODU's environmental research and
                community development work? Reach out to us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WorldWetlandsDay;
